var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"toast"}},[(_vm.visible)?_c('div',{staticClass:"Toast",attrs:{"role":"status","aria-live":"polite"}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }